import APIService from './APIService';

export default {
  getAll() {
    return APIService.apiCall().get('/sequenciamentos-eletricos/get-all');
  },
  getById(id) {
    return APIService.apiCall().get(`/sequenciamentos-eletricos/get-by-id/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/sequenciamentos-eletricos/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/sequenciamentos-eletricos/excluir/${id}`);
  },
  save(postData) {
    return APIService.apiCall().post('/sequenciamentos-eletricos/save', JSON.stringify(postData));
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`/sequenciamentos-eletricos/logs-tecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
